import React, {useState} from 'react';
import { makeStyles } from '@material-ui/styles';
import {Paper,Grid } from '@material-ui/core';
import {Form,TypeShipmentList} from './components';
import {DeleteDialog} from "../../components";
import mockData from "./components/TypeShipmentList/data";
import { EditTypeShipment } from './components/EditTypeShipment';


const useStyles = makeStyles(theme => ({
    root:{
        padding: theme.spacing(4)
    },
    formContainer: {
        display:'flex',
        justifyContent:'center',
        flexDirection:'column',
        padding: theme.spacing(4)
    },
    listContainer:{

        height:'100%',
    },
    input:{
        marginTop:theme.spacing(4)
    },
    ReactCropContainer:{
        marginTop: theme.spacing(6),
        padding:theme.spacing(3),
        border:'3px dashed rgba(0,0,0,0.1)'
    },
    alertContainer:{
        padding:theme.spacing(2),
        marginTop: theme.spacing(15),
        backgroundColor:theme.palette.primary.light+'1c',
        border: '2px solid '+theme.palette.primary.dark,
        borderRadius:4,
        '&  > *':{
            color:theme.palette.primary.dark
        },
    },
    alertIcon:{
        margin:-8,
        marginLeft:theme.spacing(1)
    }
}));

const TypeShipment = () => {
    const classes = useStyles();
    const [showDeleteDialog,setShowDeleteDialog]=useState(false);
    const toggleDeleteDialog=()=> setShowDeleteDialog(!showDeleteDialog);

    const [showEditDialog, setEditInfoDialog] = useState(false);
    const toggleEditDialog = () => setEditInfoDialog(!showEditDialog);

    const [data] = useState(mockData);


    const [idSel, setIdSelDialog] = useState('0');


  function handleIdChange(newId) {
    setIdSelDialog(newId);
  }



    return (
        <React.Fragment>
        <DeleteDialog onClose={toggleDeleteDialog} open={showDeleteDialog} title="حذف نوع بار" desc="ایا مایل به حذف این نوع بار هستید؟"/>
       
        <EditTypeShipment
        onAccept={toggleEditDialog}
        onClose={toggleEditDialog}
        data={data || undefined}
        id={idSel}
        title="اطلاعات بیشتر"
        open={showEditDialog}
      />
        <div className={classes.root}>
            <Grid
                container
                justify="space-between"
            >
                <Grid
                    item
                    xs={12}
                    sm={5}
                >
                    <Paper className={classes.formContainer}>
                        <Form />
                    </Paper>

                </Grid>
                <Grid item xs={12} sm={6}>
                    <Paper className={classes.listContainer}>
                        <TypeShipmentList ChangeId={handleIdChange} onEdit={toggleEditDialog} onDelete={toggleDeleteDialog}/>
                    </Paper>
                </Grid>
            </Grid>
        </div>
        </React.Fragment>
    );
};


export default TypeShipment;
